<template>
  <ul class="clock-picker">
    <li v-for="option in enabledOptions" :class="optionClass(option)"  @click="selectOption(option)">
      <div class="picker-option-color" :style="colorStyle(option)"></div>
      <span>
        {{ option.label }}
      </span>
    </li>
  </ul>
</template>

<script>
import Checkbox from "./Checkbox.vue";
import { stripePattern } from "./appUtility.js";

export default {
  components: { Checkbox },
  props: [
    "bins",
    "options", 
    "selectedOption"
  ],
  computed: {
    enabledOptions() {
      return this.options.filter(option => 
        option.pickerCondition == null ||
        option.pickerCondition(this.bins)
      );
    }
  },
  methods: {
    optionClass(option) {
      return {
        "picker-option": true,
        selected: option == this.selectedOption
      };
    },
    colorStyle(option) {
      if (option.striped) {
        let color = option.color;
        let offColor = this.options[0].color;
        return stripePattern(color, offColor);
      }
      else {
        return { background: option.color };
      }
    },
    selectOption(option) {
      this.$emit('update:selectedOption', option);
    }
  }
}
</script>

<style scoped>
.picker-option {
  cursor: pointer;
  white-space: nowrap;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  display: flex;
  align-items: center;
  border-radius: 3px;
  font-family: Reddit Mono;
}
.picker-option.selected {
  font-weight: bold;
  background: rgba(150, 202, 255);
}
.picker-option-color {
  width: 25px;
  height: 27px;
  border-radius: 5px;
  border: 1px solid #aaa;
  align-self: stretch;
}
.picker-option.selected .picker-option-color {
  border: 1px solid #333;
}
.picker-option span {
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
}
</style>